let resolveGoogleMapsInitPromise;

const initGoogleMapsPromise = new Promise((resolve) => {
    resolveGoogleMapsInitPromise = resolve;
});

export default function init() {

    if (window.loadGoogleMapsApi !== undefined) {
        window.loadGoogleMapsApi(function () {
            resolveGoogleMapsInitPromise(window.google);
        });
    } else {
        console.error('window.loadGoogleMapsApi is undefined');
    }

    return initGoogleMapsPromise;
}